import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogMaterials } from "../../../repositories/CatalogMaterialRepository";
import { TableMaterial } from "../components/TableMaterial";
import { useCatalogMaterialContext } from "../context/CatalogMaterialContext";

type Props = {};
export const CatalogMaterialPage = (props: Props) => {
  const { actions } = useCatalogMaterialContext();
  const { materialId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogMaterialFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogMaterials();
    if (resp.ok) {
      const materials = get(resp, "data.tables[0].rows", []);
      actions.setMaterials(materials);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getCatalogMaterialFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Materials"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableMaterial
              materialId={materialId}
              isLoading={isLoading}
              getCatalogMaterialFromAPI={getCatalogMaterialFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
